import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Coffee, X } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function ExitIntentModal({ onBook }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onLeave = (e) => {
      if (e.clientY > 10 || sessionStorage.getItem("exit-nudge")) return;
      sessionStorage.setItem("exit-nudge", "1");
      trackEvent("exit_intent_shown");
      setShow(true);
    };
    document.documentElement.addEventListener("mouseleave", onLeave);
    return () => document.documentElement.removeEventListener("mouseleave", onLeave);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[100] bg-tpeco-ink/60 backdrop-blur-sm flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setShow(false)}
          data-testid="exit-intent-overlay"
        >
          <motion.div
            className="relative card-brutal max-w-md w-full p-8 text-center !rounded-[2rem]"
            initial={{ scale: 0.8, y: 40 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.85, y: 30, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            onClick={(e) => e.stopPropagation()}
            data-testid="exit-intent-modal"
          >
            <button
              onClick={() => setShow(false)}
              className="absolute top-4 right-4 text-neutral-400 hover:text-tpeco-ink transition-colors"
              aria-label="Close"
              data-testid="exit-intent-close"
            >
              <X className="w-5 h-5" strokeWidth={2.5} />
            </button>
            <span className="mx-auto w-16 h-16 rounded-full bg-tpeco-blue text-white flex items-center justify-center">
              <Coffee className="w-8 h-8" strokeWidth={2} />
            </span>
            <h3 className="mt-4 font-display uppercase text-4xl leading-[0.95]">
              OI! BEFORE<br /><span className="bg-tpeco-pink text-white px-3 rounded-2xl inline-block">YOU GO…</span>
            </h3>
            <p className="mt-4 text-sm font-semibold text-neutral-700">
              Cold shower tomorrow? Nah. Grab the first <span className="font-extrabold">7AM slot</span> online and we'll
              rock up with a <span className="font-extrabold text-tpeco-pink">free coffee</span> from a local café.
              Hot water AND caffeine — sorted by 8.
            </p>
            <button
              onClick={() => { setShow(false); onBook(); }}
              className="btn-brutal w-full mt-6"
              data-testid="exit-intent-book-button"
            >
              <Coffee className="w-5 h-5" /> GRAB THE 7AM SLOT
            </button>
            <button
              onClick={() => setShow(false)}
              className="mt-3 text-xs font-bold uppercase tracking-widest text-neutral-400 hover:text-tpeco-ink transition-colors"
              data-testid="exit-intent-dismiss"
            >
              Nah, I like cold showers
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
